module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAJpJREFUWEft2UEKgCAUhGHFmyS46v4XqZXwuokUEQrRKobgBX/rBobPWWk0syWEMAef3xrNbPfZ7Wo1CrbWcill81C21jqllOxWMOccPZTrHfrJDkEKvjweBF+CPX5HEEFVQM2zQQRVATXPBhFUBdQ8G0RQFVDzbBBBVUDNs0EEVQE1zwYRVAXU/P826P4KWD2Sr/LnFbDrZ4gD/yEpUHlPRPcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/checkBox-icon-0.png
// module id = OX0s
// module chunks = 1